// eslint-disable-next-line import/prefer-default-export
export const GetterTypesFromIncidentList = {
  CURRENT_INCIDENT: 'CURRENT_INCIDENT',
  CURRENT_INCIDENT_LOADING_STATE: 'CURRENT_INCIDENT_LOADING_STATE',
  CURRENT_INCIDENT_ERROR_STATE: 'CURRENT_INCIDENT_ERROR_STATE',
  CURRENT_INCIDENT_ID: 'CURRENT_INCIDENT_ID',
};
